/** The different endpoint actions available for the Treaty route. */
export enum TreatyActions {
  Actions = 'actions',
  Committees = 'committees'
}
